module.exports = __webpack_public_path__ + "img/dwa_new.ff590daf.svg";